import { render, staticRenderFns } from "./m_attm.vue?vue&type=template&id=4a4d8306&scoped=true"
import script from "./m_attm.vue?vue&type=script&lang=js"
export * from "./m_attm.vue?vue&type=script&lang=js"
import style0 from "./m_attm.vue?vue&type=style&index=0&id=4a4d8306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4d8306",
  null
  
)

export default component.exports